import {
  getMatchResults,
  Match,
  matchCompleteByByesOrForfeits,
} from "model/Match/Match";
import { getRoster } from "model/Roster/Roster";

export type SacSeasonRecord = {
  rosterId: string;
  position: number | undefined;
  wins: number;
  loses: number;
};

export type SacSeasonRecordWithDisplay = {
  record: SacSeasonRecord;
  orgId: string | undefined;
  displayName: string | undefined;
};

const createSacSeasonRecord = (rosterId: string): SacSeasonRecord => {
  return {
    rosterId,
    wins: 0,
    loses: 0,
    position: undefined,
  };
};

export const calculateSacSeasonRecords = (
  rosterIds: string[],
  matches: Match[]
) => {
  const records = new Map<string, SacSeasonRecord>();
  rosterIds.forEach((id) => {
    records.set(id, createSacSeasonRecord(id));
  });

  for (let matchI = 0; matchI < matches.length; matchI++) {
    const match = matches[matchI];
    if (!match.isComplete) {
      continue;
    }

    for (let rosterI = 0; rosterI < rosterIds.length; rosterI++) {
      const rosterId = rosterIds[rosterI];
      const rosterRecord = records.get(rosterId);
      const matchRoster = getRoster(match.teams.rosters, rosterId);
      const result = matchCompleteByByesOrForfeits(match.teams.rosters)
        ? "W"
        : getMatchResults(match)?.[rosterId];
      if (!matchRoster || !rosterRecord || !result) {
        continue;
      }

      if (result === "W") {
        rosterRecord.wins++;
      } else if (result === "L") {
        rosterRecord.loses++;
      }
    }
  }

  const sortedRecords = Array.from(records.values()).sort(compareRecords);
  if (sortedRecords.length === 0) {
    return [];
  }

  sortedRecords[0].position = 1;
  for (let i = 1; i < sortedRecords.length; i++) {
    if (compareRecords(sortedRecords[i - 1], sortedRecords[i]) === 0) {
      sortedRecords[i].position = sortedRecords[i - 1].position;
    } else {
      sortedRecords[i].position = i + 1;
    }
  }
  return sortedRecords;
};

const compareRecords = (a: SacSeasonRecord, b: SacSeasonRecord): number => {
  return b.wins - a.wins;
};
